var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Presentacion'),_c('RedesSociales'),_c('SobreNosotros')],1)}
var staticRenderFns = []

export { render, staticRenderFns }